export enum FilterTypes {
  folder = 'folder',
  closed = 'closed',
  finished = 'finished',
  inProgress = 'in_progress',
  pending = 'pending',
  premieres = 'premieres',
  upcoming = 'upcoming',
  popular = 'popular',
}
